export const assessmentTemplate = [
  {
    _id: "omniMSOnboard",
    omniAudit: {
      auditVersion: "1",
      omniRevision: "1",
      omniSchema: "assessmentTemplate",
      omniSchemaVersion: "1",
      writtenBy: null,
      createdBy: "melissaadmin9999",
      createdDate: "2023-07-21T00:00:00Z",
      modifiedBy: "melissaadmin9999",
      modifiedDate: "2023-07-21T00:00:00Z",
      isActive: true,
    },
    omniData: {
      omniType: "omniMSOnboard",
      omniTypeVersion: 1,
      title: "MS Onboarding",
      purpose: "Onboard new MS patients",
      description:
        "The information you provide will help us understand your personal health needs. We use this to match you to clinical trials.",
      duration: "Around 15 minutes",
      directions:
        "Follow the onscreen instructions after you begin.</br></br>You can take this assessment again any time you experince a change in your health.",
      attribution: "",
      validated: "true",
      startDate: null,
      completeDate: null,
      selfAssessment: true,
      questions: [
        {
          omniID: "mso1",
          shortTitle: "subjectDateOfBirth",
          numberText: "1",
          text: "What is {subject name's/your} date of birth?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "date",
          multiSelectText: "false",
          answerOptions: [
            {
              value: "",
              text: "Date of Birth",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "mso2",
          shortTitle: "subjectNeurologistReason",
          numberText: "2",
          text: "{has/have} {subject name/you} been diagnosed with any of the following?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "button",
          multiSelectText: "true",
          answerOptions: [
            {
              value: "alz",
              text: "Alzheimer's disease (ALZ)",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
              isExclusive: false,
            },
            {
              value: "ep",
              text: "Epilepsy",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
              isExclusive: false,
            },
            {
              value: "mig",
              text: "Migraines",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
              isExclusive: false,
            },
            {
              value: "ms",
              text: "Multiple Sclerosis (MS)",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
              isExclusive: false,
            },
            {
              value: "pd",
              text: "Parkinson's disease",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
              isExclusive: false,
            },
            {
              value: "none",
              text: "None",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
              isExclusive: true,
            },
            {
              value: "unsure",
              text: "I do not know",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
              isExclusive: true,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "mso3",
          shortTitle: "subjectMotivation",
          numberText: "3",
          text: "What motivates {subject name/you} to seek treatment?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "freeText",
          multiSelectText: "false",
          answerOptions: [
            {
              value: "",
              text: "",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "mso4",
          shortTitle: "subjectMedications",
          numberText: "4",
          text: "Please select any medications {subject name/you} {is/are} taking.",
          subText: "Medication List",
          helpText: "",
          instructions: "",
          displayType: "button",
          multiSelectText: "true",
          answerOptions: [
            {
              value: "aubagio",
              text: "Aubagio (teriflunomide)",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
              isExclusive: false,
            },
            {
              value: "mayzent",
              text: "Mayzent (siponimod)",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
              isExclusive: false,
            },
            {
              value: "diroximel",
              text: "Diroximel fumarate",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
              isExclusive: false,
            },
            {
              value: "interferonbeta",
              text: "Interferon beta (Avonex, Rebif)",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
              isExclusive: false,
            },
            {
              value: "glatirameracetate",
              text: "Glatiramer acetate (Copaxone, Glatopa))",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
              isExclusive: false,
            },
            {
              value: "ofatumumab",
              text: "Ofatumumab (Kesimpta)",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
              isExclusive: false,
            },
            {
              value: "nitrates",
              text: "Nitrates",
              subText:
                "nitroglycerin (NTG), isosorbide mononitrate (ISMN), isosorbide dinitrate (ISDN)",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
              isExclusive: false,
            },
            {
              value: "phosphodiesteraseInhibitors",
              text: "phosphodiesterase 5 (PDE5) inhibitors",
              subText:
                "sildenafil (Viagra), tadalafil (Cialis), vardenafil (Levitra, Staxyn), avanafil (Stendra)",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
              isExclusive: false,
            },
            {
              value: "other",
              text: "Something Else",
              subText: "",
              helpText: "",
              nextQuestionID: "mso4a",
              isLast: false,
              isExclusive: false,
            },
            {
              value: "none",
              text: "None",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: true,
              isExclusive: true,
            },
            {
              value: "unsure",
              text: "I Don't Know",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: false,
              isExclusive: true,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
        {
          omniID: "mso4a",
          shortTitle: "subjectAdditionalMedications",
          numberText: "3",
          text: "What other medications are {subject name/you} taking?",
          subText: "",
          helpText: "",
          instructions: "",
          displayType: "freeText",
          multiSelectText: "false",
          answerOptions: [
            {
              value: "",
              text: "",
              subText: "",
              helpText: "",
              nextQuestionID: "",
              isLast: true,
            },
          ],
          answerValue: null,
          answerDate: null,
        },
      ],
      assessmentResults: { finalResult: null },
    },
  },
];

export const assessmentScoring = [
  {
    typeID: "omniMSOnboard",
    algorithms: [
      {
        name: "sum",
        minScore: 0,
        maxScore: 20,
        formula: null,
        questions: [],
      },
    ],
  },
];
